import { apiClient } from './authService';

// Detailed, period-aware statistics for the « Statistique de ventes » and
// « Statistique générale » pages. period = 7d | 30d | 90d | month | year,
// ou un objet { start: 'YYYY-MM-DD', end: 'YYYY-MM-DD' } (plage calendrier).
const statisticsService = {
  getStatistics: async (period = '30d') => {
    try {
      const params = typeof period === 'object' && period?.start
        ? { start: period.start, end: period.end }
        : { period };
      const response = await apiClient.get('statistics/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching statistics:', error);
      throw error.response?.data || { message: 'Error fetching statistics' };
    }
  },

  // Historique d'action complet : { day: 'YYYY-MM-DD' } pour un jour précis,
  // { start, end } pour une plage libre, sinon { period } pour toute la
  // période (sans le plafond de l'aperçu).
  getActionHistory: async ({ period = '30d', day = null, start = null, end = null } = {}) => {
    try {
      const params = day ? { day } : (start && end ? { start, end } : { period });
      const response = await apiClient.get('statistics/actions/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching action history:', error);
      throw error.response?.data || { message: 'Error fetching action history' };
    }
  },
};

export default statisticsService;
